import { Component, type ReactNode } from 'react';

export class AdminModuleBoundary extends Component<{ children: ReactNode }, { failed: boolean }> {
  override state = { failed: false };

  static getDerivedStateFromError() { return { failed: true }; }

  override render() {
    if (this.state.failed) return <section className="admin-card" role="alert"><h2>此模块暂时无法打开</h2><p>可以先从左侧进入其他模块，或重新加载后再试。未提交的编辑内容可能需要重新填写。</p><button onClick={() => window.location.reload()}>重新加载后台</button></section>;
    return this.props.children;
  }
}
